<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">

</script>

<style>
</style>

